import AsyncStorage from '@react-native-async-storage/async-storage';
let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Image,
  ActivityIndicator,
  Linking,
} from 'react-native';
import { Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
export default function ApplicationDetailsScreen({ navigation, route }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_applicationdetailsscreen`;
    apiFetch('/api/data/applications?sort=created_at&order=desc&limit=20').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  // States
  const [isLoading, setIsLoading] = useState(true);
  const [application, setApplication] = useState(null);
  const [activeTab, setActiveTab] = useState('details');
  const [error, setError] = useState(null);

  // Mock application data
  const mockApplications = [
    {
      id: '1',
      name: 'John Doe',
      position: 'Senior Mechanical Engineer',
      company: 'Rolls-Royce',
      location: 'Derby, UK',
      appliedDate: '15 May 2025',
      status: 'Under Review',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
      email: 'john.doe@example.com',
      phone: '+44 7123 456789',
      coverLetter:
        "I am writing to express my interest in the Senior Mechanical Engineer position at Rolls-Royce. With over 8 years of experience in mechanical engineering and a specialization in turbine design, I believe I am well-qualified for this role.\n\nMy experience at General Electric has given me extensive knowledge in designing and analyzing mechanical components for aircraft engines. I have led several successful projects that improved engine efficiency by 12% and reduced manufacturing costs by 8%.\n\nI am particularly excited about Rolls-Royce's commitment to sustainable aviation and would be thrilled to contribute to your innovative projects in this area. My background in thermal analysis and stress testing would be valuable assets to your engineering team.\n\nThank you for considering my application. I look forward to the opportunity to discuss how my skills and experience align with your needs.",
      resume: 'resume_john_doe.pdf',
      education: [
        {
          degree: 'Master of Science in Mechanical Engineering',
          institution: 'Imperial College London',
          year: '2017',
        },
        {
          degree: 'Bachelor of Engineering in Mechanical Engineering',
          institution: 'University of Manchester',
          year: '2015',
        },
      ],
      experience: [
        {
          title: 'Senior Mechanical Engineer',
          company: 'General Electric',
          duration: '2020 - Present',
          description:
            'Led design and analysis of turbine components for aircraft engines',
        },
        {
          title: 'Mechanical Engineer',
          company: 'Airbus',
          duration: '2017 - 2020',
          description: 'Developed mechanical systems for commercial aircraft',
        },
      ],
      skills: [
        'CAD/CAM',
        'Finite Element Analysis',
        'Thermal Analysis',
        'GD&T',
        'CATIA',
        'Project Management',
      ],
      jobId: '1',
    },
    {
      id: '2',
      name: 'Jane Smith',
      position: 'Electrical Engineer',
      company: 'BAE Systems',
      location: 'Bristol, UK',
      appliedDate: '10 May 2025',
      status: 'Interview Scheduled',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
      email: 'jane.smith@example.com',
      phone: '+44 7234 567890',
      coverLetter:
        "I am excited to apply for the Electrical Engineer position at BAE Systems. With my background in electrical systems design and experience in the defense sector, I believe I would be a valuable addition to your team.\n\nDuring my time at Thales, I specialized in power distribution systems and electronic warfare components. I successfully delivered projects under strict deadlines and security requirements, always meeting or exceeding specifications.\n\nI am particularly interested in BAE Systems' work on next-generation defense electronics and would welcome the opportunity to contribute to these cutting-edge developments.\n\nThank you for considering my application. I am looking forward to discussing how my skills align with your requirements.",
      resume: 'resume_jane_smith.pdf',
      education: [
        {
          degree: 'Master of Engineering in Electrical Engineering',
          institution: 'University of Bristol',
          year: '2018',
        },
        {
          degree: 'Bachelor of Science in Electrical Engineering',
          institution: 'University of Southampton',
          year: '2016',
        },
      ],
      experience: [
        {
          title: 'Electrical Systems Engineer',
          company: 'Thales Group',
          duration: '2019 - Present',
          description:
            'Design and development of electrical systems for defense applications',
        },
        {
          title: 'Graduate Electrical Engineer',
          company: 'Rolls-Royce',
          duration: '2018 - 2019',
          description:
            'Worked on electrical power systems for aircraft engines',
        },
      ],
      skills: [
        'Circuit Design',
        'PCB Layout',
        'Power Systems',
        'MATLAB',
        'Altium Designer',
        'Signal Processing',
      ],
      jobId: '2',
    },
    {
      id: '3',
      name: 'Sam Wilson',
      position: 'Software Developer',
      company: 'Dyson',
      location: 'Malmesbury, UK',
      appliedDate: '5 May 2025',
      status: 'Application Submitted',
      avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
      email: 'sam.wilson@example.com',
      phone: '+44 7345 678901',
      coverLetter:
        "Please consider my application for the Software Developer position at Dyson. I am a skilled developer with experience in embedded systems and consumer electronics software.\n\nAt Samsung, I developed firmware for smart home appliances, focusing on energy efficiency and user experience. I am proficient in C/C++ programming and have experience with real-time operating systems.\n\nI am particularly impressed by Dyson's innovative approach to consumer technology and would be excited to contribute to your next generation of smart products.\n\nThank you for your consideration. I look forward to discussing my qualifications further.",
      resume: 'resume_sam_wilson.pdf',
      education: [
        {
          degree: 'Master of Science in Computer Science',
          institution: 'University of Bath',
          year: '2019',
        },
        {
          degree: 'Bachelor of Engineering in Computer Engineering',
          institution: 'University of Exeter',
          year: '2017',
        },
      ],
      experience: [
        {
          title: 'Embedded Software Engineer',
          company: 'Samsung Electronics',
          duration: '2020 - Present',
          description: 'Developing firmware for smart home appliances',
        },
        {
          title: 'Software Developer',
          company: 'ARM',
          duration: '2019 - 2020',
          description: 'Worked on embedded software for IoT devices',
        },
      ],
      skills: [
        'C/C++',
        'Embedded Systems',
        'RTOS',
        'Python',
        'Git',
        'Debugging Tools',
      ],
      jobId: '3',
    },
  ];

  // Load application details when component mounts or route params change
  useEffect(() => {
    // Reset states when navigating to a new application
    setIsLoading(true);
    setError(null);
    setApplication(null);

    if (route.params?.applicationId) {
      loadApplicationDetails(route.params.applicationId);
    } else {
      setError('No application ID provided');
      setIsLoading(false);
    }
  }, [route.params?.applicationId]); // Only re-run when applicationId changes

  // Load application details
  const loadApplicationDetails = applicationId => {
    if (!applicationId) {
      setError('Invalid application ID');
      setIsLoading(false);
      return;
    }

    // Simulate API call
    setTimeout(() => {
      try {
        const applicationData = mockApplications.find(
          app => app.id === applicationId
        );

        if (!applicationData) {
          setError(`Application with ID ${applicationId} not found`);
          setIsLoading(false);
          return;
        }

        setApplication(applicationData);

        // Reset error state if successful
        setError(null);
      } catch (err) {
        setError('Error loading application details');
        console.error('Error loading application details:', err);
      } finally {
        setIsLoading(false);
      }
    }, 1000);
  };

  // Get status color based on application status
  const getStatusColor = status => {
    switch (status) {
      case 'Under Review':
        return '#0e4e96'; // Blue
      case 'Interview Scheduled':
        return '#19abb5'; // Teal
      case 'Application Submitted':
        return '#64748B'; // Gray
      case 'Offer Received':
        return '#16a34a'; // Green
      case 'Rejected':
        return '#dc2626'; // Red
      default:
        return '#64748B'; // Default gray
    }
  };

  // Handle contact via email
  const handleEmailContact = () => {
    if (!application) return;
    Linking.openURL(`mailto:${application.email}`);
  };

  // Handle contact via phone
  const handlePhoneContact = () => {
    if (!application) return;
    Linking.openURL(`tel:${application.phone}`);
  };

  // Handle view job details
  const handleViewJob = () => {
    if (!application) return;
    navigation.navigate('JobDetails', { jobId: application.jobId });
  };

  // Render application details
  const renderApplicationDetails = () => {
    if (!application) return null;

    return (
      <ScrollView
        style={styles.contentContainer}
        showsVerticalScrollIndicator={false}
      >
        <View style={styles.applicationHeader}>
          <Image
            source={{ uri: (application.avatar && application.avatar.startsWith('http')) ? application.avatar : undefined }}
            style={styles.avatar}
            defaultSource={require('../../../assets/default-avatar.png')}
          />
          <View style={styles.applicationHeaderInfo}>
            <Text style={styles.applicantName}>{application.name}</Text>
            <Text style={styles.positionText}>{application.position}</Text>
            <Text style={styles.companyText}>{application.company}</Text>
          </View>
        </View>

        <View style={styles.statusSection}>
          <View
            style={[
              styles.statusBadge,
              { backgroundColor: getStatusColor(application.status) + '20' }, // 20% opacity
            ]}
          >
            <Text
              style={[
                styles.statusText,
                { color: getStatusColor(application.status) },
              ]}
            >
              {application.status}
            </Text>
          </View>
        </View>

        <View style={styles.detailsSection}>
          <View style={styles.detailItem}>
            <Ionicons name="location-outline" size={20} color="#64748B" />
            <Text style={styles.detailText}>{application.location}</Text>
          </View>
          <View style={styles.detailItem}>
            <Ionicons name="calendar-outline" size={20} color="#64748B" />
            <Text style={styles.detailText}>
              Applied {application.appliedDate}
            </Text>
          </View>
          <View style={styles.detailItem}>
            <Ionicons name="mail-outline" size={20} color="#64748B" />
            <Text style={styles.detailText}>{application.email}</Text>
          </View>
          <View style={styles.detailItem}>
            <Ionicons name="call-outline" size={20} color="#64748B" />
            <Text style={styles.detailText}>{application.phone}</Text>
          </View>
        </View>

        {activeTab === 'details' && (
          <>
            <View style={styles.sectionContainer}>
              <Text style={styles.sectionTitle}>Cover Letter</Text>
              <View style={styles.coverLetterContainer}>
                <Text style={styles.coverLetterText}>
                  {application.coverLetter}
                </Text>
              </View>
            </View>

            <View style={styles.sectionContainer}>
              <Text style={styles.sectionTitle}>Resume</Text>
              <TouchableOpacity style={styles.resumeButton}>
                <Ionicons
                  name="document-text-outline"
                  size={24}
                  color="#0e4e96"
                />
                <Text style={styles.resumeButtonText}>
                  {application.resume}
                </Text>
              </TouchableOpacity>
            </View>
          </>
        )}

        {activeTab === 'profile' && (
          <>
            <View style={styles.sectionContainer}>
              <Text style={styles.sectionTitle}>Education</Text>
              {application.education.map((edu, index) => (
                <View key={index} style={styles.educationItem}>
                  <Text style={styles.educationDegree}>{edu.degree}</Text>
                  <Text style={styles.educationInstitution}>
                    {edu.institution}
                  </Text>
                  <Text style={styles.educationYear}>{edu.year}</Text>
                </View>
              ))}
            </View>

            <View style={styles.sectionContainer}>
              <Text style={styles.sectionTitle}>Experience</Text>
              {application.experience.map((exp, index) => (
                <View key={index} style={styles.experienceItem}>
                  <Text style={styles.experienceTitle}>{exp.title}</Text>
                  <View style={styles.experienceSubheader}>
                    <Text style={styles.experienceCompany}>{exp.company}</Text>
                    <Text style={styles.experienceDuration}>
                      {exp.duration}
                    </Text>
                  </View>
                  <Text style={styles.experienceDescription}>
                    {exp.description}
                  </Text>
                </View>
              ))}
            </View>

            <View style={styles.sectionContainer}>
              <Text style={styles.sectionTitle}>Skills</Text>
              <View style={styles.skillsContainer}>
                {application.skills.map((skill, index) => (
                  <View key={index} style={styles.skillBadge}>
                    <Text style={styles.skillText}>{skill}</Text>
                  </View>
                ))}
              </View>
            </View>
          </>
        )}

        <View style={styles.actionButtonsContainer}>
          <TouchableOpacity
            style={styles.actionButton}
            onPress={handleEmailContact}
          >
            <Ionicons name="mail-outline" size={20} color="#64748B" />
            <Text style={styles.actionButtonText}>Email</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.actionButton}
            onPress={handlePhoneContact}
          >
            <Ionicons name="call-outline" size={20} color="#64748B" />
            <Text style={styles.actionButtonText}>Call</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.actionButton, styles.primaryActionButton]}
            onPress={handleViewJob}
          >
            <Ionicons name="briefcase-outline" size={20} color="#fff" />
            <Text style={styles.primaryActionButtonText}>View Job</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    );
  };

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="dark-content" backgroundColor="#f8fafc" />

      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <Ionicons name="arrow-back" size={24} color="#0f172a" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Application Details</Text>
        <View style={styles.headerRight} />
      </View>

      {/* Tabs */}
      <View style={styles.tabsContainer}>
        <TouchableOpacity
          style={[styles.tab, activeTab === 'details' && styles.activeTab]}
          onPress={() => setActiveTab('details')}
        >
          <Text
            style={[
              styles.tabText,
              activeTab === 'details' && styles.activeTabText,
            ]}
          >
            Application
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.tab, activeTab === 'profile' && styles.activeTab]}
          onPress={() => setActiveTab('profile')}
        >
          <Text
            style={[
              styles.tabText,
              activeTab === 'profile' && styles.activeTabText,
            ]}
          >
            Profile
          </Text>
        </TouchableOpacity>
      </View>

      {/* Content */}
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#0e4e96" />
          <Text style={styles.loadingText}>Loading application details...</Text>
        </View>
      ) : error ? (
        <View style={styles.errorContainer}>
          <Ionicons name="alert-circle-outline" size={60} color="#dc2626" />
          <Text style={styles.errorTitle}>Error</Text>
          <Text style={styles.errorDescription}>{error}</Text>
          <TouchableOpacity
            style={styles.retryButton}
            onPress={() => loadApplicationDetails(route.params?.applicationId)}
          >
            <Text style={styles.retryButtonText}>Retry</Text>
          </TouchableOpacity>
        </View>
      ) : (
        renderApplicationDetails()
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#f8fafc',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: '#f8fafc',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#0f172a',
  },
  headerRight: {
    width: 40,
  },
  tabsContainer: {
    flexDirection: 'row',
    backgroundColor: '#f1f5f9',
    padding: 4,
    marginHorizontal: 16,
    marginVertical: 12,
    borderRadius: 8,
  },
  tab: {
    flex: 1,
    paddingVertical: 8,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
  },
  activeTab: {
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  tabText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#64748b',
  },
  activeTabText: {
    color: '#0e4e96',
    fontWeight: '600',
  },
  contentContainer: {
    flex: 1,
    padding: 16,
  },
  applicationHeader: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  avatar: {
    width: 70,
    height: 70,
    borderRadius: 35,
    marginRight: 16,
  },
  applicationHeaderInfo: {
    flex: 1,
    justifyContent: 'center',
  },
  applicantName: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#0f172a',
    marginBottom: 4,
  },
  positionText: {
    fontSize: 16,
    color: '#334155',
    marginBottom: 2,
  },
  companyText: {
    fontSize: 14,
    color: '#64748b',
  },
  statusSection: {
    marginBottom: 16,
  },
  statusBadge: {
    alignSelf: 'flex-start',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  statusText: {
    fontSize: 14,
    fontWeight: '600',
  },
  detailsSection: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 5,
    elevation: 2,
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  detailText: {
    fontSize: 14,
    color: '#334155',
    marginLeft: 12,
  },
  sectionContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 5,
    elevation: 2,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#0f172a',
    marginBottom: 12,
  },
  coverLetterContainer: {
    backgroundColor: '#f8fafc',
    borderRadius: 8,
    padding: 12,
  },
  coverLetterText: {
    fontSize: 14,
    color: '#334155',
    lineHeight: 20,
  },
  resumeButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#e0f2fe',
    padding: 12,
    borderRadius: 8,
  },
  resumeButtonText: {
    fontSize: 14,
    color: '#0e4e96',
    fontWeight: '500',
    marginLeft: 8,
  },
  educationItem: {
    marginBottom: 16,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#f1f5f9',
  },
  educationDegree: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0f172a',
    marginBottom: 4,
  },
  educationInstitution: {
    fontSize: 14,
    color: '#334155',
    marginBottom: 2,
  },
  educationYear: {
    fontSize: 14,
    color: '#64748b',
  },
  experienceItem: {
    marginBottom: 16,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#f1f5f9',
  },
  experienceTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#0f172a',
    marginBottom: 4,
  },
  experienceSubheader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  experienceCompany: {
    fontSize: 14,
    color: '#334155',
  },
  experienceDuration: {
    fontSize: 14,
    color: '#64748b',
  },
  experienceDescription: {
    fontSize: 14,
    color: '#334155',
    lineHeight: 20,
  },
  skillsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  skillBadge: {
    backgroundColor: '#e0f2fe',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    marginRight: 8,
    marginBottom: 8,
  },
  skillText: {
    fontSize: 14,
    color: '#0e4e96',
    fontWeight: '500',
  },
  actionButtonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    flex: 1,
    marginHorizontal: 4,
  },
  actionButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#64748b',
    marginLeft: 8,
  },
  primaryActionButton: {
    backgroundColor: '#0e4e96',
    borderColor: '#0e4e96',
  },
  primaryActionButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#fff',
    marginLeft: 8,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  loadingText: {
    marginTop: 12,
    fontSize: 16,
    color: '#64748b',
  },
  errorContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#dc2626',
    marginTop: 12,
    marginBottom: 8,
  },
  errorDescription: {
    fontSize: 16,
    color: '#64748b',
    textAlign: 'center',
    marginBottom: 20,
  },
  retryButton: {
    backgroundColor: '#0e4e96',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  retryButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
});
